import FilterMixins from './FilterMixins';
import ComputedMixins from './ComputedMixins';
import MethodMixin from './MethodMixin';
import SwiperAutoplayMixin from './SwiperAutoplayMixin';

export default {
    mixins: [FilterMixins, ComputedMixins, MethodMixin, SwiperAutoplayMixin],
};
